import { defineMessages } from "react-intl";

export const variantCreateMessages = defineMessages({
  variantCreatedSuccess: {
    id: "IeoGgH",
    defaultMessage: "Variant created",
    description: "variant created success message",
  },
});
